// Generated with util/create-component.js
import React, { useState, useRef, useEffect } from "react";
import { DropdownMenuProps } from "./DropdownMenu.types";
import { StyledDropDownMenu } from "./DropdownMenu.styles"
import Button from "../Button/Button";
import Menu from "../Menu/Menu";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

const DropdownMenu: React.FC<DropdownMenuProps> = ({
    label,
    arrow = "dropdown",
    children,
    theme,
    ...rest
}) => {
    const [hidden, setHidden] = useState<boolean>(true);
    let ref = useRef(null);

    const handleClickAffectingMenu = (event) => {
        event.target !== ref.current && setHidden(true);
    };

    useEffect(() => {
        document.addEventListener("click", handleClickAffectingMenu, true);
        return () =>
            document.removeEventListener("click", handleClickAffectingMenu, true);
    }, []);

    return (
        <StyleSheetManager shouldForwardProp={isPropValid}>
            <StyledDropDownMenu data-testid="DropdownMenu" className="dd-container">
                <Button
                    innerRef={ref}
                    label={label}
                    arrow={arrow}
                    onClick={() => setHidden(!hidden)}
                    theme={theme}
                    {...rest}
                />
                <div className={`dd-menu ${hidden ? "hidden" : ""}`}>
                    <Menu.Container theme={theme}>{children}</Menu.Container>
                </div>
            </StyledDropDownMenu>
        </StyleSheetManager>
    );
}

export default DropdownMenu;

